import { useSelector } from "react-redux";
import Datos from "./_Datos";

export default function Resultados() {
  const { step } = useSelector((state) => state.cotizacionesReducer.cotizacion);

  return step > 4 ? <Datos /> : <></>;
}
